<template>
  <div id="ProjBidDemand">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="projectReplyBoxTop">
      <ProjBidBtnReply v-if="answerStatus=='101'" text="参与应答" class="replyProject eb-button-red eb-button-small" :project="project"
      />
    </div>
    <div class="card-box">
      <eb-card-two>
        <ProjBidDemandProject :project="project" />
      </eb-card-two>
    </div>
    <div class="eb-line"></div>
    <ProjectViewSummary :project="project" class="panel-box" />
    <div class="eb-line"></div>
    <ProjRuleViewList :ruleList="ruleList" :basePanelIndex="0">
    </ProjRuleViewList>
    <ProjectViewHandsontable class="panel-box" :title="projectHandsontableTitle" :hotSettings="shoppingListHotSettings" />
    <div class="eb-line"></div>
    <ProjectViewPreText class="panel-box" :title="projectViewCommentTitle" :content="project['projectComment']" />
    <div class="eb-line" v-if="answerStatus=='101'"></div>
    <div class="eb-button-group" v-if="answerStatus=='101'">
      <ProjBidBtnReply text="参与应答" class="eb-button-group-btn eb-button-orange eb-button-big" :project="project" />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ProjBidBtnReply from '@/components/project/bid/list/ProjBidBtnReply';
import ProjBidDemandProject from '@/components/project/bid/demand/ProjBidDemandProject';
import ebCardTwo from '@/components/common/card/eb-card-two';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjRuleViewList from '@/components/project/common/ruleview/ProjRuleViewList';
import ProjectViewHandsontable from '@/components/project/common/ProjectViewHandsontable';
import ProjectViewPreText from '@/components/project/common/ProjectViewPreText';
import { getProjectDetailById } from '@/services/proj/bid-project-service';
import { handleProjViewRuleList } from '@/services/proj/project-service';
import { answerOrEditReply } from '@/services/proj/bid-reply-service';
export default {
  name: 'ProjBidDemand',
  components: {
    ebHeader,
    ebBreakCrumb,
    ProjBidBtnReply,
    ProjBidDemandProject,
    ebCardTwo,
    ProjectViewSummary,
    ProjRuleViewList,
    ProjectViewHandsontable,
    ProjectViewPreText
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      user: this.$store.state.user.userInfo,
      createId: this.$route.params.createId,
      project: {},
      projectViewCommentTitle: {
        number: '',
        text: '报价表备注'
      },
      projectHandsontableTitle: {
        number: '',
        text: '分项报价表'
      },
      previewSupplier: {},
      ruleList: [],
      answerStatus: '',
      shoppingListHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价'],
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 200,
            readOnly: true
          },

          {
            data: 'productDesc',
            type: 'text',
            width: 350,
            readOnly: true
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 60,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'productNum',
            width: 75,
            className: 'htRight',
            readOnly: true,
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric'
          },
          {
            data: 'shoppingPrice',
            width: 120,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            }
          },
          {
            data: 'shoppingSubtotal',
            width: 147,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            }
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([
          answerOrEditReply(this.projectId, this.createId),
          getProjectDetailById(this.projectId)
        ]);
        if (data1.returnCode === '01' || data1.returnCode === '00') {
          this.answerStatus = data1.data;
        }
        if (data2.returnCode === '01') {
          this.project = data2.project;
          this.ruleList = handleProjViewRuleList(data2.ruleList);
          this.shoppingListHotSettings.data = data2['shopList'];
          this.changeTitleNumber(parseInt(this.ruleList.length));
        } else if (data2.returnCode === '00') {
          this.$message.error(data2.message);
        } else {
          this.$message.error('获取项目信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    changeTitleNumber: function(number) {
      this.projectHandsontableTitle.number = number + 1;
      this.projectViewCommentTitle.number = number + 2;
    }
  }
};
</script>
<style lang="less" scoped>
#ProjBidDemand {
  .projectReplyBoxTop {
    display: flex;
    justify-content: flex-end;
    padding: 20px 50px;
  }
  .card-box {
    margin-bottom: 30px;
  }
}
</style>
